function BenefitTile({ imageKey, title, description }: BenefitTileProps) {
  return (
    <li className="flex items-start space-x-4">
      {imageKey && <img
        className="flex-shrink-0 w-1/6"
        src={`/images/for-brands/${imageKey}.svg`}
      />}
      {title && description && <span>
        <h3 className="font-semibold mb-2 text-2xl text-[#4ECDC4]">{title}</h3>
        <p className="">{description}</p>
      </span>}
    </li>
  )
}

export interface BenefitTileProps {
  imageKey: string | null
  title?: string
  description?: string
}

export default BenefitTile
